var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.precise)?_c('span',[_vm._v("\n    "+_vm._s(_vm.c)+"\n  ")]):_c('span',[_c('numAbv',{attrs:{"num":_vm.c}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }